<template>
  <generic-create :model="model">
    <template v-slot:form="{ error, submit }">
      <person-category-form :error="error" :loading="false" @submit="submit" />
    </template>
  </generic-create>
</template>

<script>
import PersonCategoryForm from "./Form"
import model from "./model"

export default {
  components: { PersonCategoryForm },
  data() {
    return { model }
  },
}
</script>
